export default "__VITE_ASSET__DvLOxBxL__"